<template>
    <div>

        <!-- Product Drawer -->
        <product-drawer :data="data"></product-drawer>

        <!-- Dev check data -->
        <!--<div class="code">-->
        <!--    <pre>{{data}}</pre>-->
        <!--</div>-->

    </div>
</template>

<script>
    import { ProductDrawer } from "../components";

    export default {
        name: "v-products",
        components: {
            ProductDrawer
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>
